// Actions
export const setCommercial = ({ commit }, payload) => {
  commit('SET_COMMERCIAL', payload)
}
export const addCommercial = ({ commit }, payload) => {
  commit('ADD_COMMERCIAL', payload)
}
export const setCommercialLoading = ({ commit }, payload) => {
  commit('SET_COMMERCIAL_LOADING', payload)
}

export const setHistoricalSenders = ({ commit }, payload) => {
  commit('SET_HISTORICAL_SENDERS', payload)
}
export const addHistoricalSenders = ({ commit }, payload) => {
  commit('ADD_HISTORICAL_SENDERS', payload)
}
export const setHistoricalSendersLoading = ({ commit }, payload) => {
  commit('SET_HISTORICAL_SENDERS_LOADING', payload)
}

export const setHistoricalConversations = ({ commit }, payload) => {
  commit('SET_HISTORICAL_CONVERSATIONS', payload)
}
export const addHistoricalConversations = ({ commit }, payload) => {
  commit('ADD_HISTORICAL_CONVERSATIONS', payload)
}
export const setHistoricalConversationsLoading = ({ commit }, payload) => {
  commit('SET_HISTORICAL_CONVERSATIONS_LOADING', payload)
}

export const setGoogleStoreToken = ({ commit }, payload) => {
  commit('SET_GOOGLE_STORE_TOKEN', payload)
}
export const addGoogleStoreToken = ({ commit }, payload) => {
  commit('ADD_GOOGLE_STORE_TOKEN', payload)
}
export const setGoogleStoreTokenLoading = ({ commit }, payload) => {
  commit('SET_GOOGLE_STORE_TOKEN_LOADING', payload)
}

export const setHistoricalConversation = ({ commit }, payload) => {
  commit('SET_HISTORICAL_CONVERSATION', payload)
}
export const addHistoricalConversation = ({ commit }, payload) => {
  commit('ADD_HISTORICAL_CONVERSATION', payload)
}
export const setHistoricalConversationLoading = ({ commit }, payload) => {
  commit('SET_HISTORICAL_CONVERSATION_LOADING', payload)
}
export const setSendWhatsappMessage = ({ commit }, payload) => {
  commit('SET_SEND_WHATSAPP_MESSAGE', payload)
}
export const addSendWhatsappMessage = ({ commit }, payload) => {
  commit('ADD_SEND_WHATSAPP_MESSAGE', payload)
}
export const setSendWhatsappMessageLoading = ({ commit }, payload) => {
  commit('SET_SEND_WHATSAPP_MESSAGE_LOADING', payload)
}

export const setPermissions = ({ commit }, payload) => {
  commit('SET_PERMISSIONS', payload)
}
export const addPermissions = ({ commit }, payload) => {
  commit('ADD_PERMISSIONS', payload)
}
export const setPermissionsLoading = ({ commit }, payload) => {
  commit('SET_PERMISSIONS_LOADING', payload)
}

export const setStatusPermissions = ({ commit }, payload) => {
  commit('SET_STATUS_PERMISSIONS', payload)
}
export const addStatusPermissions = ({ commit }, payload) => {
  commit('ADD_STATUS_PERMISSIONS', payload)
}
export const setStatusPermissionsLoading = ({ commit }, payload) => {
  commit('SET_STATUS_PERMISSIONS_LOADING', payload)
}

export const setIntegrateWithCalendar = ({ commit }, payload) => {
  commit('SET_INTEGRATE_WITH_CALENDAR', payload)
}
export const addIntegrateWithCalendar = ({ commit }, payload) => {
  commit('ADD_INTEGRATE_WITH_CALENDAR', payload)
}
export const setIntegrateWithCalendarLoading = ({ commit }, payload) => {
  commit('SET_INTEGRATE_WITH_CALENDAR_LOADING', payload)
}

export const setStatusAllSdr = ({ commit }, payload) => {
  commit('SET_STATUS_ALL_SDR', payload)
}
export const addStatusAllSdr = ({ commit }, payload) => {
  commit('ADD_STATUS_ALL_SDR', payload)
}
export const setStatusAllSdrLoading = ({ commit }, payload) => {
  commit('SET_STATUS_ALL_SDR_LOADING', payload)
}

export const setSettings = ({ commit }, payload) => {
  commit('SET_SETTINGS', payload)
}
export const addSettings = ({ commit }, payload) => {
  commit('ADD_SETTINGS', payload)
}
export const setSettingsLoading = ({ commit }, payload) => {
  commit('SET_SETTINGS_LOADING', payload)
}

export const setInternalVariables = ({ commit }, payload) => {
  commit('SET_INTERNAL_VARIABLES', payload)
}
export const addInternalVariables = ({ commit }, payload) => {
  commit('ADD_INTERNAL_VARIABLES', payload)
}
export const setInternalVariablesLoading = ({ commit }, payload) => {
  commit('SET_INTERNAL_VARIABLES_LOADING', payload)
}

export const setExcelVariables = ({ commit }, payload) => {
  commit('SET_EXCEL_VARIABLES', payload)
}
export const addExcelVariables = ({ commit }, payload) => {
  commit('ADD_EXCEL_VARIABLES', payload)
}
export const setExcelVariablesLoading = ({ commit }, payload) => {
  commit('SET_EXCEL_VARIABLES_LOADING', payload)
}

